import { useEffect } from 'react';
import { mountGoldSparkles } from '@/lib/goldSparkles';

/** Mounted once; its fixed, non-interactive canvas never affects page layout. */
export function GoldenSparkles() {
  useEffect(() => mountGoldSparkles(), []);
  return null;
}
